export const explorations = [
  {
    slug: 'apple-scroll-effect',
    title: 'Apple Scroll Effect',
    category: 'Técnica',
    shortDesc: 'Scroll-driven image sequence al estilo Apple — canvas 2D + 95 frames pre-renderizados, lerp suavizado y precarga inteligente.',
    desc: 'La técnica exacta que Apple usa en apple.com/macbook y apple.com/iphone: una sección de 400vh actúa como pista de scroll, un canvas sticky de 100vh pinta el frame correspondiente al progress del usuario.\n\nSin Three.js, sin video, sin WebGL — solo canvas 2D + imágenes pre-renderizadas. El scrubbing se suaviza con lerp (factor 0.15), la precarga prioriza los frames más cercanos al progreso actual y el resize recalcula el canvas sin glitch.',
    sections: [
      {
        label: 'La técnica',
        text: 'Una sección de 400vh hace de pista de scroll. Dentro hay un contenedor sticky de 100vh con un canvas. Al hacer scroll, calculo el progress (0→1) y pinto el frame correspondiente de una secuencia de 95 PNGs pre-renderizados. Sin Three.js, sin video — solo canvas 2D.',
      },
      {
        label: 'Los detalles',
        text: 'Lerp con factor 0.15 para suavizar el scrubbing. Precarga que prioriza frames cercanos al frame actual (no 1, 2, 3... sino ±1, ±2, ±3...). DPR correcto para pantallas retina. object-fit: contain calculado a mano. Respeta prefers-reduced-motion.',
      },
    ],
    tech: 'Canvas 2D · JS · Vue',
    thumbnail: require('@/assets/exercises/container-thumbnail-apple-scroll.png'),
    component: 'AppleScrollEffect',
    wide: true,
    accent: 'var(--milo-steel)',
    accentBg: '#000',
    fullbleed: true,
  },
  {
    slug: 'authkit-hero',
    title: 'AuthKit Hero',
    category: 'Componentes',
    shortDesc: 'Réplica del hero de AuthKit: spotlight beams, grid lines, corner dots y cards flotantes con animated border.',
    desc: 'Réplica del hero de AuthKit: spotlight beams, grid lines, corner dots y cards flotantes con animated border.',
    tech: 'CSS · Vue · @property',
    thumbnail: require('@/assets/exercises/container-thumbnail-authentic.png'),
    component: 'AuthKitHero',
    wide: false,
    accent: 'var(--milo-steel)',
    accentBg: '#05060f',
    fullbleed: true,
  },
  {
    slug: 'file-upload-card',
    title: 'AudIA',
    category: 'Side project',
    shortDesc: 'Side project para transcribir grabaciones de juntas con Whisper AI — todo local, sin subir nada a la nube.',
    desc: 'Mi esposa trabajaba en juntas donde siempre se grababan los audios — a veces de hasta una hora. Al terminar su jornada, tenía que sentarse a escuchar cada grabación, transcribir todo lo que se decía y consolidarlo en un acta formal. Una tarea completamente manual que le consumía horas de su tiempo libre. En 2026, eso no tiene ningún sentido.\n\nConstruí este side project en Vue.js conectado a un servidor local en Python: recibe el archivo de audio, lo procesa con Whisper — el modelo de reconocimiento de voz de OpenAI que corre directo en tu computadora sin internet — y devuelve el texto en tiempo real mientras trabaja, como si alguien lo estuviera escribiendo frente a ti. Sin servidores de pago, sin subir tus reuniones a la nube. Todo local, porque los servicios de procesamiento de audio en la nube son costosos y las grabaciones de juntas son privadas.',
    sections: [
      {
        label: 'El problema',
        text: 'Mi esposa trabajaba en juntas donde siempre se grababan los audios — a veces de hasta una hora. Al terminar su jornada, tenía que sentarse a escuchar cada grabación, transcribir todo lo que se decía y consolidarlo en un acta formal. Una tarea completamente manual que le consumía horas de su tiempo libre. En 2026, eso no tiene ningún sentido.',
      },
      {
        label: 'La solución',
        text: 'Construí este side project en Vue.js conectado a un servidor local en Python: recibe el archivo de audio, lo procesa con Whisper — el modelo de reconocimiento de voz de OpenAI que corre directo en tu computadora sin internet — y devuelve el texto en tiempo real mientras trabaja, como si alguien lo estuviera escribiendo frente a ti. Sin servidores de pago, sin subir tus reuniones a la nube. Todo local, porque los servicios de procesamiento de audio en la nube son costosos y las grabaciones de juntas son privadas.',
      },
    ],
    tech: 'Vue · Python · Whisper AI',
    thumbnail: require('@/assets/exercises/container-thumbnail-file-upload-card.svg'),
    component: 'FileUploadCard',
    wide: false,
    accent: 'var(--milo-indigo)',
    accentBg: 'oklch(0.96 0.025 280)',
  },
  {
    slug: 'card-ikea',
    title: 'Card',
    category: 'Componentes',
    desc: 'Efecto hover con escala de grises sobre imagen y cambio de color en llamado a la acción.',
    tech: 'CSS · JS',
    thumbnail: require('@/assets/exercises/container-thumbnail-card-min.png'),
    component: 'CardIkea',
    wide: true,
    accent: 'var(--milo-forest)',
    accentBg: 'oklch(0.96 0.025 165)',
  },
  {
    slug: 'accordion',
    title: 'Accordion',
    category: 'Componentes',
    desc: 'Contenedores collapsables con animación suave y gestión de estado.',
    tech: 'CSS · JS',
    thumbnail: require('@/assets/exercises/container-thumbnail-accordion-min.png'),
    component: 'CardAvatar',
    wide: false,
    accent: 'var(--milo-indigo)',
    accentBg: 'oklch(0.96 0.025 280)',
  },
  {
    slug: 'tween-number',
    title: 'Incremento de números',
    category: 'Componentes',
    desc: 'Contador animado que incrementa suavemente hacia el valor objetivo al entrar al viewport.',
    tech: 'CSS · JS',
    thumbnail: require('@/assets/exercises/container-thumbnail-numbers-min.png'),
    component: 'TweenNumber',
    wide: false,
    accent: 'var(--milo-terra)',
    accentBg: 'oklch(0.96 0.025 45)',
  },
  {
    slug: 'music-player',
    title: 'Player',
    category: 'Componentes',
    desc: 'Reproductor de música con controles estilizados en CSS puro.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-thumbnail-player-min.png'),
    component: 'MusicPlayer',
    wide: false,
    accent: 'var(--milo-steel)',
    accentBg: 'oklch(0.96 0.025 245)',
  },
  {
    slug: 'glow-button',
    title: 'Efecto brillo sobre botón',
    category: 'Componentes',
    desc: 'Botón con efecto de brillo luminoso que sigue el cursor usando CSS custom properties.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-thumbnail-button-min.png'),
    component: 'GlowButtonEffect',
    wide: false,
    accent: 'var(--milo-amber)',
    accentBg: 'oklch(0.96 0.025 75)',
  },
  {
    slug: 'card-info-team',
    title: 'Card Info Team',
    category: 'Componentes',
    desc: 'Tarjeta de perfil con acciones rápidas para equipos de trabajo.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-thumbnail-profile-actions-min.png'),
    component: 'CardNotifications',
    wide: false,
    accent: 'var(--milo-forest)',
    accentBg: 'oklch(0.96 0.025 165)',
  },
  {
    slug: 'settings',
    title: 'Settings Component',
    category: 'Componentes',
    desc: 'Panel de configuración de visibilidad con toggles y estados persistentes.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-thumbnail-visibility-settings-min.png'),
    component: 'VisibilitySettings',
    wide: false,
    accent: 'var(--milo-indigo)',
    accentBg: 'oklch(0.96 0.025 280)',
  },
  {
    slug: 'social-card',
    title: 'Social Card',
    category: 'Componentes',
    desc: 'Tarjeta de red social con estadísticas y acciones de usuario.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-social-card.png'),
    component: 'CardSocial',
    wide: false,
    accent: 'var(--milo-terra)',
    accentBg: 'oklch(0.96 0.025 45)',
  },
  {
    slug: 'upload-progress',
    title: 'Upload Progress',
    category: 'Componentes',
    desc: 'Indicador de progreso de carga con estados de éxito, error y carga.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-upload.png'),
    component: 'UploadProgress',
    wide: false,
    accent: 'var(--milo-steel)',
    accentBg: 'oklch(0.96 0.025 245)',
  },
  {
    slug: 'onboarding-card',
    title: 'Onboarding Card',
    category: 'Componentes',
    desc: 'Tarjeta de bienvenida con pasos guiados para nuevos usuarios.',
    tech: 'CSS',
    thumbnail: require('@/assets/exercises/container-onboarding-card.png'),
    component: 'OnboardingCard',
    wide: false,
    accent: 'var(--milo-amber)',
    accentBg: 'oklch(0.96 0.025 75)',
  },
  {
    slug: 'hamburguer-menu',
    title: 'Hamburguer Menu',
    category: 'Componentes',
    desc: 'Menú flotante animado con botón MENU estilizado, indicadores de punto y navegación con GSAP.',
    tech: 'CSS · GSAP',
    thumbnail: require('@/assets/exercises/container-thumbnail-hamburguer-menu.png'),
    component: 'HamburguerMenu',
    wide: false,
    accent: 'var(--milo-forest)',
    accentBg: 'oklch(0.96 0.025 165)',
  },
  {
    slug: 'raycast-features',
    title: 'Raycast Features',
    category: 'Componentes',
    desc: 'Sección interactiva de features con texto resaltable, progress bar automático y mockups animados — inspirado en raycast.com.',
    tech: 'CSS · JS · Vue',
    thumbnail: require('@/assets/exercises/container-thumbnail-raycast-features.svg'),
    component: 'RaycastFeatures',
    wide: false,
    accent: 'var(--milo-steel)',
    accentBg: '#111110',
    fullbleed: true,
  },
  {
    slug: 'oryzo-header',
    title: 'Oryzo Header',
    category: 'Componentes',
    desc: 'Header de producto editorial con glassmorphism, imagen hero de fondo y tipografía display.',
    tech: 'CSS · Layout',
    thumbnail: require('@/assets/background-image-table.png'),
    component: 'OryzoHeader',
    wide: false,
    accent: 'var(--milo-indigo)',
    accentBg: 'oklch(0.96 0.025 280)',
    fullbleed: true,
  },
  {
    slug: 'agent-card',
    title: 'Agent Card',
    category: 'Componentes',
    desc: 'Tarjeta de agente AI con waveform generado por ondas sinusoidales, badges de herramientas y fondo de cuadrícula CSS.',
    tech: 'CSS · Vue',
    thumbnail: require('@/assets/exercises/container-card-overview.png'),
    component: 'AgentCard',
    wide: false,
    accent: 'var(--milo-terra)',
    accentBg: 'oklch(0.96 0.025 45)',
  },
];

export function getExploration(slug) {
  return explorations.find(e => e.slug === slug) || null;
}
